import { Component, DestroyRef, effect, inject, input, model, output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-tutorial-modal',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonModule],
  templateUrl: './tutorial-modal.component.html',
  styleUrl: './tutorial-modal.component.scss',
})
export class TutorialModalComponent {
  open = model(false);
  title = input('');
  subtitle = input('');
  videoSrc = input('');
  instructions = input('');
  acceptLabel = input('Kaydet');
  state = input<'form' | 'loading' | 'success'>('form');

  accept = output<{ username: string; password: string }>();

  readonly username = new FormControl('', { nonNullable: true, validators: [Validators.required] });
  readonly password = new FormControl('', { nonNullable: true, validators: [Validators.required] });

  showPassword = false;

  private autoCloseTimeout?: ReturnType<typeof setTimeout>;

  constructor() {
    const destroyRef = inject(DestroyRef);

    effect(() => {
      if (this.state() === 'success') {
        this.autoCloseTimeout = setTimeout(() => this.open.set(false), 2500);
      }
    });

    destroyRef.onDestroy(() => {
      if (this.autoCloseTimeout) clearTimeout(this.autoCloseTimeout);
    });
  }

  get isValid(): boolean {
    return this.username.valid && this.password.valid;
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onAccept(): void {
    if (!this.isValid) return;
    this.accept.emit({ username: this.username.value, password: this.password.value });
  }
}
